<app-tabs-header [labelText]="'Search for a benefit by name'"
                 [iconName]="'add'"
                 [showButton]="true"
                 [buttonText]="'Add Benefit'"
                 (valueChanged)="onValueChanged($event)"
                 (emitClickEvent)="openBenefitDialog()">
</app-tabs-header>

<div *ngIf="benefitsDataSource" class="mat-elevation-z8 table-container">

  <table mat-table multiTemplateDataRows [dataSource]="benefitsDataSource"
         matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" matTooltip="EDIT Benefit"
                  (click)="editEntry($event, row.benefitId)">
          edit
        </mat-icon>
        <mat-icon class="table-icon" matTooltip="DELETE Benefit"
                  (click)="onDeleteBenefitConfirmation($event, row)">
          delete
        </mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="benefitId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
      <td *matCellDef="let row" mat-cell>{{row.benefitId}}</td>
    </ng-container>

    <ng-container matColumnDef="benefitCode">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Code</th>
      <td *matCellDef="let row" mat-cell>{{row.benefitCode}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
      <td class="w-45" *matCellDef="let row" mat-cell>{{row.name}}</td>
    </ng-container>

    <ng-container matColumnDef="ageMin">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Age Min</th>
      <td *matCellDef="let row" mat-cell>{{row.ageMin}}</td>
    </ng-container>

    <ng-container matColumnDef="ageMax">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Age Max</th>
      <td *matCellDef="let row" mat-cell>{{row.ageMax}}</td>
    </ng-container>

    <!-- Expanded Row -->
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="benefitsDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == benefitsExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="benefitsDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: benefitsDisplayedColumns;"
        class="row" [class.expanded-row]="benefitsExpandedRow == row"
        (click)="benefitsExpandedRow = benefitsExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  </table>

  <mat-paginator #benefitsPaginator (page)="pageChanged($event)"
                 [length]="benefitsTableControl.length" [pageSize]="benefitsTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="benefitsTableControl.pageSizeOptions">
  </mat-paginator>

</div>
